import gql from 'graphql-tag';

export default gql`
  mutation invitationUpdateStore($input: InvitationsStoreInput) {
    invitationUpdateStore(input: $input) {
      userErrors {
        field
        message
      }
      success
    }
  }
`;
